import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Chat,
  FooterContainer,
  Language,
} from "./styles";



const Footer = ({ t }: { t: TFunction }) => {

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between">
            <Col lg={10} md={10} sm={12} xs={12}>
              <Language>{t("Contact")}</Language>
              <Para>
                {t(`Do you have any question? Feel free to reach out.`)}
              </Para>
              <a href="tel:+27633627114">
                <Chat>{t(`0633627114`)}</Chat>
              </a>
              <a href="mailto:info@ambienttrading.co.za">
                <Chat>{t(`info@ambienttrading.co.za`)}</Chat>
              </a>
            </Col>
            <Col lg={8} md={8} sm={12} xs={12}>
              <Language>{t("Address")}</Language>
              <Para>Cambridge Office Park</Para>
              <Para>5 Bauhinia St</Para>
              <Para>Highveld Techno Park</Para>
              <Para>Centurion, 0169</Para>
            </Col>
          </Row>
          <Row justify="space-between">
            
            <Col lg={8} md={8} sm={12} xs={12}>
              <Title>{t("Company")}</Title>
              <Para>{`Ambient Trading Enterprise (PTY) LTD`}</Para>
              <Para>Company registration: 2022/660418/07</Para>
              <Para>VAT Number: 4160317287</Para>
            </Col>
          </Row>
        </Container>
      </FooterSection>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="101px"
                  height="64px"
                />
              </LogoContainer>
            </NavLink>
            <Para>
                {`© 2025 Ambient Trading Enterprise (PTY) LTD`}
            </Para>
            <FooterContainer>
            </FooterContainer>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
